export type ClientBuildInfo = {
  fingerprint: string | null;
  commit: string | null;
  builtAt: string | null;
};

let cached: ClientBuildInfo | null | undefined;

/** Fingerprint of the main bundle actually running in this tab (not SW-cached metadata). */
export function getRunningClientFingerprint(): string | null {
  if (typeof document === 'undefined') {
    return null;
  }

  const scripts = document.querySelectorAll('script[src*="/static/js/main."]');
  for (const node of scripts) {
    const src = (node as HTMLScriptElement).src;
    const filename = src.split('/').pop()?.split('?')[0];
    if (filename?.startsWith('main.') && filename.endsWith('.js')) {
      return filename;
    }
  }

  return null;
}

export async function loadClientBuildInfo(): Promise<ClientBuildInfo | null> {
  const runningFingerprint = getRunningClientFingerprint();
  if (runningFingerprint) {
    cached = {
      fingerprint: runningFingerprint,
      commit: null,
      builtAt: null,
    };
    return cached;
  }

  if (cached !== undefined) {
    return cached;
  }

  try {
    const response = await fetch('/client-build.json', { cache: 'no-store' });
    if (!response.ok) {
      cached = null;
      return null;
    }

    const data = (await response.json()) as Partial<ClientBuildInfo>;
    cached = {
      fingerprint: data.fingerprint ?? null,
      commit: data.commit ?? null,
      builtAt: data.builtAt ?? null,
    };
    return cached;
  } catch {
    cached = null;
    return null;
  }
}

export function resetClientBuildInfoCacheForTests(): void {
  cached = undefined;
}
